var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActiveIonToggle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 6,
    width: 12,
    height: 12,
    rx: 6,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.25 5.25H6.75C3.02812 5.25 0 8.27812 0 12C0 15.7219 3.02812 18.75 6.75 18.75H17.25C20.9719 18.75 24 15.7219 24 12C24 8.27812 20.9719 5.25 17.25 5.25ZM17.25 17.25C16.2116 17.25 15.1966 16.9421 14.3333 16.3652C13.4699 15.7883 12.797 14.9684 12.3996 14.0091C12.0023 13.0498 11.8983 11.9942 12.1009 10.9758C12.3034 9.95738 12.8035 9.02192 13.5377 8.28769C14.2719 7.55346 15.2074 7.05345 16.2258 6.85088C17.2442 6.64831 18.2998 6.75227 19.2591 7.14963C20.2184 7.54699 21.0383 8.2199 21.6152 9.08326C22.1921 9.94661 22.5 10.9616 22.5 12C22.4985 13.3919 21.9449 14.7264 20.9607 15.7107C19.9764 16.6949 18.6419 17.2485 17.25 17.25Z",
    fill: "#065EEA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveIonToggle);
export default __webpack_public_path__ + "static/media/active_ion_toggle.62af2a0e0b8d9a8033ded88b037abffc.svg";
export { ForwardRef as ReactComponent };